// Auth constants
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_LOADED = 'USER_LOADED';
export const USER_LOADING = 'USER_LOADING';
export const AUTH_ERROR = 'AUTH_ERROR';

export const SEND_VERIFICATION_REQUEST = 'SEND_VERIFICATION_REQUEST';
export const SEND_VERIFICATION_SUCCESS = 'SEND_VERIFICATION_SUCCESS';
export const SEND_VERIFICATION_FAIL = 'SEND_VERIFICATION_FAIL';

export const LOGOUT = 'LOGOUT';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';